// ======================================================
//       invocies_header
// ======================================================

export const GET_INVOICE_HEADER = "GET_INVOICE_HEADER";
export const GET_INVOICE_HEADER_UPDATE = "GET_INVOICE_HEADER_UPDATE";
export const COPY_INVOICE_HEADER = "COPY_INVOICE_HEADER";

export const GET_INVOICE_DATA = "GET_INVOICE_DATA";

// ======================================================
//         invoices_lines
// ======================================================

export const GET_INVOICE_LINES = "GET_INVOICE_LINES";
export const GET_INVOICE_LINES_UPDATE = "GET_INVOICE_LINES_UPDATE";
export const COPY_INVOICE_LINES = "COPY_INVOICE_LINES";